'use client';

import GraphQLProvider from '@/providers/GraphQLProvider';
import HeroSection from '@/components/publicSearch/heroSection/HeroSection';

/**
 * Bundles GraphQLProvider and HeroSection into one lazy chunk so the Shell
 * can skip the Apollo dynamic import entirely for the /search route.
 * The Shell renders immediately; this chunk loads in parallel.
 */
export default function SearchHeroWithApollo() {
  return (
    <GraphQLProvider>
      <HeroSection />
    </GraphQLProvider>
  );
}
